import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import "../../../styles/csv_upload.css";
import label from "../../labels/postExaminationProcessObjective_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { toastr } from 'react-redux-toastr';

import {
    getAdvertisementsList,
    getExamslistByAdvertisementId,
    getSubjectlistByExamId,
    getDownloadAnswerKeyDataBySubjectId,
    updateAnswerKeyData,
    getAllApprovalAnswerKeyListPagination,
    getExaminersAndModeratorReportData,
    uploadBarcodeCsv,
    getSupervisorlist
} from "../../actions/postExaminationProcessObjectiveActions";
import { getYearList, getAdvertisementlistByYear, downloadSampleCSVFile } from "../../../common/actions/commonActions";

// import { uploadVenueCsv, resetVenueErrorList } from '../actions/venueManagementAction';

const ImportBarcodeCSV = (props) => {
    const { register, errors } = useForm({
        mode: "onChange"
    });
    // const { venueErrorList } = useSelector(
    //     (state) => state.venueManagementReducer,
    //     shallowEqual
    // );

    let [file, setFile] = useState("");


    const dispatch = useDispatch();
    let { examList, advertisementList, subjectList, supervisorList, getAnswerKeyData, allUnapprovalEntityList, unapprovalPageNoCounter } = useSelector(
        (state) => state.postExamProcessObjectReducer,
        shallowEqual
    );
    const [csvHeader, setCsvHeader] = useState([]);
    const [reloadItem, setReloadItem] = useState(0);
    const [csvErr, setCsvErr] = useState("");
    const [saveButtonFlag, setSaveButtonFlag] = useState(false);

    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedSupervisor, setSelectedSupervisor] = useState("")

    useEffect(() => {
        // dispatch(resetVenueErrorList());
        dispatch(getSupervisorlist());
        // eslint-disable-next-line
    }, []);
    let { yearList, allYearList } = useSelector(
        (state) => state.common,
        shallowEqual
    );
    const fileInputRef = useRef(null);
    useEffect(() => {

    }, [reloadItem]);
    const onAdvertisementChange = (ele) => {
        let selectedValue = ele;
        setSelectedAdvertNo(selectedValue);
        examList.length = 0;
        subjectList.length = 0;
        setSelectedExam("");
        setSelectedSubject("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onExamChange = (ele) => {
        let selectedValue = ele;
        subjectList.length = 0;
        setSelectedExam(selectedValue);
        setSelectedSubject("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onSubjectChange = (ele) => {
        let selectedValue = ele;
        setSelectedSubject(selectedValue);
        setSaveButtonFlag(false);
        // onSubmit(selectedValue);
        setReloadItem(!reloadItem);
        // setEditedValues({});
    };

    const onSupervisorChange = (ele) => {
        let selectedValue = ele;
        setSelectedSupervisor(selectedValue);
        setSaveButtonFlag(false);
        // onSubmit(selectedValue);
        setReloadItem(!reloadItem);
        // setEditedValues({});
    };

    const reload = () => {
        setReloadItem((item) => item + 1);
    }
    const onChangeImage = (event) => {
        setCsvErr("");
        if (event.target.files.length == 0) {
            return
        }
        setFile(event.target.files[0])
    }

    const handleSampleDownload = () => {
        dispatch(downloadSampleCSVFile("barcodeRollNo"))
    }


    const uploadFile = () => {
        let data = {};
        data.file = file;
        data.action = 'upload';
        if (data.file !== "") {
            setCsvErr("");
            dispatch(uploadBarcodeCsv(data, selectedExam, selectedSubject, cancelModal, props.onCancelButton))
            setSaveButtonFlag(true);
        } else {
            setCsvErr("This field is required");
        }
    }

    const cancelModal = () => {
        // dispatch(resetVenueErrorList());
        props.setShowImportBarcode(false)
        setSaveButtonFlag(false)
        setFile("")
        setCsvErr("")
    }
    const onSelectYear = (ele) => {
        let selectedValue = ele;
        selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
        if (allYearList) {
            allYearList.length = 0
        }
        if (examList) {
            examList.length = 0;
        }
        if (subjectList) {
            subjectList.length = 0
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setSaveButtonFlag(true);

        setReloadItem(!reloadItem);
    };

    const handleInputClick = () => {
        if (file !== "") {
            setSaveButtonFlag(true)
        }
    }
    // useEffect(() => {
    //     if (venueErrorList && venueErrorList.length > 0) {
    //         const errors = venueErrorList.map((row) => ({
    //             venue: row
    //         }));
    //         const csvData = jsonToCsv(errors);

    //         csvHeader.length == 0 && downloadFile(csvData);
    //     }
    //     // eslint-disable-next-line
    // }, [venueErrorList]);
    const jsonToCsv = (error) => {
        const csvRows = [];

        const headers = Object.keys(error[0].venue);
        setCsvHeader(headers);
        csvRows.push(headers.join(','))
        for (let i = 0; i < error.length; i++) {
            for (const row of Object.values(error[i])) {

                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                });
                csvRows.push(values.join(','))
            }
        }
        reload();
        return csvRows.join('\n');

    }

    const downloadFile = (error) => {

        const a = document.createElement('a');
        a.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(error));

        a.setAttribute('hidden', '')

        a.setAttribute('download', 'download.csv')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }


    return (
        <div>

            <Modal size="xl" show={props.showImportBarcode} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static' >
                <Modal.Header closeButton>
                    <Modal.Title>Import Barcode and Roll No CSV File</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="row">
                            <div className="form-group col-md-2">
                                <label className="float-left">
                                    {commonLabels.selectYear}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedYear"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onSelectYear(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {yearList &&
                                        yearList.length > 0 &&
                                        yearList
                                            .map((element, index) => (
                                                <option>{element}</option>
                                                // <option key={index} value={element.id}>
                                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                // </option>
                                            ))}
                                </select>
                                {_.get("selectedYear.type", errors) ===
                                    "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                            </div>
                            <div className="form-group col-md-4">
                                <label className="float-left">
                                    {commonLabels.SelectAdvertNo}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedAdvertiseNo"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onAdvertisementChange(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {allYearList &&
                                        allYearList.length > 0 &&
                                        allYearList
                                            .filter(
                                                (element) =>
                                                    element.isDeleted == false &&
                                                    element.isActive === true
                                            )
                                            .map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                </option>
                                            ))}
                                </select>
                                {_.get("selectedAdvertiseNo.type", errors) ===
                                    "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                            </div>
                            <div className=" col-md-3">
                                <label className="float-left">
                                    {label.SelectExam}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedExam"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onExamChange(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {
                                        examList &&
                                        examList.length > 0 &&
                                        examList
                                            .filter(
                                                (element) =>
                                                    element.isDeleted == false &&
                                                    element.isActive === true
                                            )
                                            .map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            ))
                                    }
                                </select>
                                {_.get("selectedExam.type", errors) === "required" && (
                                    <p className="errorText float-left">
                                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            <div className=" col-md-3">
                                <label className="float-left">
                                    {label.SelectSubject}
                                    <span className="errorText">*</span>
                                </label>
                                <select
                                    className="form-control"
                                    name="selectedSubject"
                                    ref={register({ required: true })}
                                    onChange={(e) => {
                                        onSubjectChange(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">
                                        {commonLabels.COMBO_SELECT}
                                    </option>
                                    {
                                        subjectList &&
                                        subjectList.length > 0 &&
                                        subjectList
                                            // .filter(
                                            //     (element) =>
                                            //         element.isDeleted == false &&
                                            //         element.isActive === true
                                            // )
                                            .map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.name}({element.type?.toUpperCase()})
                                                </option>
                                            ))
                                    }
                                </select>
                                {_.get("selectedSubject.type", errors) === "required" && (
                                    <p className="errorText float-left">
                                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                            {/* <div className=" col-md-3">
                                    <label className="float-left">
                                        {label.SelectSupervisor}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedExam"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSupervisorChange(e.target.value);
                                        }}
                                    >
                                        <option>
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {
                                            supervisorList &&
                                            supervisorList.length > 0 &&
                                            supervisorList
                                                // .filter(
                                                //     (element) =>
                                                //         element.isDeleted == false &&
                                                //         element.isActive === true
                                                // )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.role}
                                                    </option>
                                                ))
                                        }
                                    </select>
                                    {_.get("selectedExam.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div> */}
                        </div>
                        <br />
                        <div className="row ml-1">
                            <input name="fileInput" type="file" accept={".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"} onChange={(event) => onChangeImage(event)} onClick={handleInputClick} ref={(e) => {
                                register({ required: true })(e); fileInputRef.current = e;
                            }} />
                            {csvErr !== "" && <p className="errorText">{csvErr}</p>}

                            <button type="button" onClick={uploadFile} className=" btn btn-primary btn-sm upload-btn-custom icon-pointer" disabled={selectedExam === '' || selectedSubject === '' || file === ''}>
                                {commonLabels.Upload}
                            </button>

                            <div className="float-right">
                                <i
                                    className={"fa fa-file-excel-o ml-2 fa-2x text-success"}
                                    aria-hidden="true"
                                    onClick={() =>
                                        handleSampleDownload()
                                    }
                                    style={{ cursor: "pointer" }}
                                    title='Download Sample Template'
                                ></i>
                            </div>
                        </div>

                        <div>
                            {/* {venueErrorList && venueErrorList.length > 0 ?
                                <table className="table table-bordered table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col" key={0} >No.</th>
                                            {csvHeader.map((ele, index) => {

                                                if (ele == 'address' || ele == 'capacity' || ele == 'coordinator_contact_number' || ele == 'coordinator_designation' || ele == 'coordinator_eEmail' || ele == 'coordinator_gender' || ele == 'coordinator_name' || ele == 'statecode' || ele == 'districtcode' || ele == 'subdistrictcode' || ele == 'villagecode' || ele == 'subdistrictcode' || ele == 'statecode' || ele == 'pincode' || ele == 'ph_facility' || ele == 'no_of_floors' || ele == 'no_of_blocks' || ele == 'mode' || ele == 'venue_name_devngr') {
                                                    return (<></>);
                                                }
                                                else {
                                                    return (<th scope="col" key={index} >{ele}</th>)
                                                }
                                            }
                                            )}

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {venueErrorList && venueErrorList.length > 0 && venueErrorList.map((ele, i) => {
                                            if (ele) {
                                                return (
                                                    <tr>
                                                        <td className="w-10 word-break text-center">{++i}</td>
                                                        <td className="word-break text-center">{ele?.exam_center_id}</td>
                                                        <td className="word-break">{ele?.venue_name}{ele?.venue_name_devngr ? ' - ' + ele?.venue_name_devngr : ''}</td>
                                                        <td className="word-break">{ele?.contact_number}</td>
                                                        <td className="word-break">{ele?.email}</td>
                                                        <td className="word-break">{ele?.benificiary_name}</td>
                                                        <td className="word-break">{ele?.beneficiary_ac}</td>
                                                        <td className="word-break">{ele?.ifsc_code}</td>
                                                        <td className="word-break">{ele?.errorMessage}</td>
                                                    </tr>
                                                )

                                            }
                                        })
                                        }

                                    </tbody>
                                </table> : ""} */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal} >Cancel</button>
                    {/* <button type="button" className="btn btn-primary" disabled={!saveButtonFlag} onClick={saveFileList}>Save</button> */}
                </Modal.Footer>

            </Modal>

        </div>
    )
}
export default ImportBarcodeCSV;